module.exports = __webpack_public_path__ + "media/images/ep5-cindy-d3d0bb53aff67b4a4a267bc877dd8c68.png";